import React from "react";

const MiningSvg = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Mining</title>
      <path
        d="M6.49999 11.5V6.50002H11.5V11.5H6.49999ZM7.99999 10H9.99999V8.00002H7.99999V10ZM6.24999 17.2693V15.5H4.30774C3.80258 15.5 3.37499 15.325 3.02499 14.975C2.67499 14.625 2.49999 14.1974 2.49999 13.6923V11.75H0.730743V10.25H2.49999V7.75002H0.730743V6.25002H2.49999V4.30777C2.49999 3.80261 2.67499 3.37502 3.02499 3.02502C3.37499 2.67502 3.80258 2.50002 4.30774 2.50002H6.24999V0.730774H7.74999V2.50002H10.25V0.730774H11.75V2.50002H13.6922C14.1974 2.50002 14.625 2.67502 14.975 3.02502C15.325 3.37502 15.5 3.80261 15.5 4.30777V6.25002H17.2692V7.75002H15.5V10.25H17.2692V11.75H15.5V13.6923C15.5 14.1974 15.325 14.625 14.975 14.975C14.625 15.325 14.1974 15.5 13.6922 15.5H11.75V17.2693H10.25V15.5H7.74999V17.2693H6.24999ZM13.6922 14C13.7692 14 13.8397 13.9679 13.9037 13.9038C13.9679 13.8398 14 13.7693 14 13.6923V4.30777C14 4.23077 13.9679 4.16027 13.9037 4.09627C13.8397 4.03211 13.7692 4.00002 13.6922 4.00002H4.30774C4.23074 4.00002 4.16024 4.03211 4.09624 4.09627C4.03208 4.16027 3.99999 4.23077 3.99999 4.30777V13.6923C3.99999 13.7693 4.03208 13.8398 4.09624 13.9038C4.16024 13.9679 4.23074 14 4.30774 14H13.6922Z"
        fill="#5663F2"
      />
    </svg>
  );
};

export default MiningSvg;
